import { StaffAuthService } from "./../staff-auth.service";
import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError, BehaviorSubject } from "rxjs";
import { catchError, filter, take, switchMap } from "rxjs/operators";
import { AppConsts } from "app/shared/consts/app-consts";
import { AppComponent } from "app/app.component";
import { CustomerAuthService } from "app/login-phone/shared/services/auth.service";
import { Router } from "@angular/router";
import { Config, menuLoginPhone } from "app/config/config";
import { ClearLocalStorageAndkeepFP } from "app/shared/util/CommonUtil";
declare var $: any;

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(
    private authService: StaffAuthService,
    private staffServices: StaffAuthService,
    private customerAuthService: CustomerAuthService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          const currentInfoUser = localStorage.getItem(
            AppConsts.currentCustomerKey
          );
          // if (!currentInfoUser) {
          //   localStorage.clear();
          //   setTimeout(() => {
          //     this.router.navigate([`${menuLoginPhone.path}`]);
          //     $(".popup-overlay").addClass("hidden");
          //     $("#popup-expire-token").removeClass("hidden");
          //   }, 500);
          //   return;
          // }
          if (
            err?.status === 0 &&
            err?.statusText?.indexOf("Unknown Error") > -1
          ) {
            //network error
            $(".popup-overlay").addClass("hidden");
            $("#popup-network-error").removeClass("hidden");
            return throwError({ msg: "Network Error" });
          }

          //renew token
          if (err.status === 401) {
            if (err.url.indexOf("auth/refreshtoken?key") < 0) {
              try {
                var tmpUser = JSON.parse(currentInfoUser);
                localStorage.setItem(
                  AppConsts.currentCustomerKey,
                  JSON.stringify({ ...tmpUser, authToken: "" })
                );
                return this.handle401Error(request, next);
              } catch (e) {
                ClearLocalStorageAndkeepFP(() => {
                  this.router.navigate([`${menuLoginPhone.path}`]);
                  $(".popup-overlay").addClass("hidden");
                  $("#popup-expire-token").removeClass("hidden");
                });
              }
            }
          } else if (err.status === 499) {
            try {
              $("#popup-check-campaignactive").removeClass("hidden");
              $("#popup-check-campaignactive").removeClass("hide");
              return this.handle401Error(request, next);
            } catch (e) {
              ClearLocalStorageAndkeepFP(() => {
                this.router.navigate([`${menuLoginPhone.path}`]);
                $(".popup-overlay").addClass("hidden");
                $("#popup-expire-token").removeClass("hidden");
              });
            }
          }
        }
        var error = "";
        if (err) {
          error = err.error.message || err.statusText;
          if (
            err?.error?.error?.code === "RequestOTPFail" &&
            err?.error?.error?.message === "InvalidResendTime"
          ) {
            error = err?.error?.error?.message;
          }

          //temp
          if (
            err.url.indexOf(Config.unileverApiPath.checkPhoneRegistered) > -1 ||
            err.url.indexOf(Config.unileverApiPath.qrlink) > -1
          ) {
            error = err.error.error;
          }

          if (err.url.indexOf(Config.utopApiPath.verifyOTP) > -1) {
            error = err.error;
          }
        }
        return throwError(error);
      })
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      const refresh_token = localStorage.getItem("refresh_token");
      if (refresh_token) {
        return this.customerAuthService
          .reNewToken({
            refresh_token: refresh_token,
            grant_type: "refresh_token",
          })
          .pipe(
            switchMap((authToken) => {
              this.isRefreshing = false;
              this.refreshTokenSubject.next(authToken.access_token);
              this.authService.updateToken(authToken.access_token);
              return next.handle(
                this.addToken(request, authToken.access_token)
              );
            }),
            catchError((err) => {
              this.isRefreshing = false;
              ClearLocalStorageAndkeepFP(() => {
                this.router.navigate([`${menuLoginPhone.path}`]);
                $(".popup-overlay").addClass("hidden");
                $("#popup-expire-token").removeClass("hidden");
              });
              return throwError(err);
            })
          );
      } else {
        this.isRefreshing = false;
        ClearLocalStorageAndkeepFP(() => {
          this.router.navigate([`${menuLoginPhone.path}`]);
          $(".popup-overlay").addClass("hidden");
          $("#popup-expire-token").removeClass("hidden");
        });
      }
    } else {
      this.isRefreshing = false;
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((jwt) => {
          return next.handle(this.addToken(request, jwt));
        })
      );
    }
  }

  private addToken(request: HttpRequest<any>, authToken: String) {
    return request.clone({
      headers: request.headers.set(
        AppConsts.authorizationKey,
        `Bearer ${authToken}`
      ),
    });
  }
}
